export const PROJECT_STEP_NEW = 'new';
export const PROJECT_STEP_ANALYSIS = 'analysis';
export const PROJECT_STEP_DISTRIBUTION = 'distribution';
export const PROJECT_STEP_RESULT = 'result';
export const PROJECT_STEP_DETAIL = 'detail';
